import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 10.5l6.492 -6.492","key":"svg-0"}],["path",{"d":"M13.496 16l6.504 -6.504z","key":"svg-1"}],["path",{"d":"M8.586 15.414l10.827 -10.827","key":"svg-2"}],["path",{"d":"M8 6a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z","key":"svg-3"}],["path",{"d":"M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2","key":"svg-4"}]]

const IconLayersSelected = createReactComponent('outline', 'layers-selected', 'LayersSelected', __iconNode);

export default IconLayersSelected;